<template>
  <Layout>
    <div class="outBox">
      <div class="container">
        <div class="header">
          <p class="note">注：回收站内容保存15天，过期后自动清除</p>
        </div>

        <div v-if="loading" class="loading">加载中...</div>
        <div v-else-if="error" class="error">{{ error }}</div>

        <div v-else-if="recycleBinItems.length > 0" class="table-container">
          <table class="table">
            <thead :style="{ backgroundColor: '#B4D0EC' }">
            <tr>
              <th>类型</th>
              <th>标题</th>
              <th>状态</th>
              <th>创建时间</th>
              <th>剩余时间</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody class="table-body">
            <tr v-for="item in recycleBinItems" :key="item.activityId">
              <td class="center-cell">
                  <div class="jlclass"
                       v-show="item.activityType == 106 || item.activityType == 105">
                      通用接龙
                  </div>
                  <div class="dkclass"
                       v-show="item.activityType == 109 ||item.activityType == 110 ||item.activityType == 104">
                      打卡签到
                  </div>
                  <div class="tzclass" v-show="item.activityType == 201">
                      通知公告
                  </div>
                  <div class="hyclass" v-show="item.activityType == 303">
                      信息核验
                  </div>
              </td>
              <td>{{ item.activityName }}</td>
              <td>
                  <span :class="getStatusClass(item.is_it_over)">
                    {{ getActivityStatus(item.is_it_over) }}
                  </span>
              </td>
              <td>{{ formatDateTime(item.createTime) }}</td>
              <td>{{ item.remainderTime }}</td>
              <td>
                <button @click="confirmRestore(item.activityId)" class="btn btn-restore">恢复</button>
                <button @click="confirmDelete(item.activityId)" class="btn btn-delete">删除</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="no-data">
          <img src="https://ossfastmake.mustke.com//static/gift/none.svg"  class="no-data-icon"  alt="none"/>
          <span class="no-data-text">暂无数据</span>
        </div>
      </div>

      <el-pagination
          v-show="tablePage.total"
          background
          layout="sizes, prev, pager, next, total"
          :page-sizes="[10, 20, 30, 40]"
          :total="tablePage.total"
          :current-page="tablePage.pageNum"
          :page-size="tablePage.pageSize"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          style="text-align: center; margin-top: 20px;"
      />
    </div>

    <!-- 恢复确认弹窗 -->
    <el-dialog title="确认恢复" :visible.sync="showRestoreDialog" @close="resetRestoreDialog" :show-close="false">
      <template slot="title">
        <CustomDialogHeader
            title="确认恢复"
            @close="resetRestoreDialog"
        />
      </template>
      <div>确定恢复此活动吗？</div>
      <template #footer>
        <el-button @click="resetRestoreDialog">取消</el-button>
        <el-button type="primary" @click="restoreActivity">确认</el-button>
      </template>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog :visible.sync="showDeleteDialog" @close="resetDeleteDialog" :show-close="false">
      <template slot="title">
        <CustomDialogHeader
            title="确认删除"
            @close="resetDeleteDialog"
        />
      </template>
      <div>确定删除此活动吗？</div>
      <template #footer>
        <el-button @click="resetDeleteDialog">取消</el-button>
        <el-button type="primary" @click="deleteActivity">确认</el-button>
      </template>
    </el-dialog>
  </Layout>
</template>

<script>
import CustomDialogHeader from '@/components/CustomDialogHeader.vue'
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { getRecycleBin, recycleBinRestore, recycleBinKill } from "@/utils/api/activity";
import copyrightConfig from "@/utils/config/changeCopyright.js";
const appid = copyrightConfig.AppID;

export default {
  page: {
    meta: [{name: "description", content: appConfig.description}],
    title: "回收站",
  },
  name: "Recycle",
  components: { Layout,CustomDialogHeader },
  data() {
    return {
      loading: false,
      error: '',
      recycleBinItems: [],
      tablePage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      showRestoreDialog: false,
      showDeleteDialog: false,
      currentItemId: null,
    };
  },
  created() {
    this.fetchRecycleBinData();
  },
  mounted() {
    // 确保标题设置生效
    this.$nextTick(() => {
      this.setPageTitle();
    });
  },
  methods: {
    // 设置页面标题
    setPageTitle() {
      // 根据 AppID 确定后缀
      let suffix = '接龙加加';
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = '报名管家';
      }

      document.title = `回收站 - ${suffix}`;
      console.log(document.title, "document.title");
    },
    async fetchRecycleBinData() {
      this.loading = true;
      this.error = '';
      try {
        const params = {
          pageSize: this.tablePage.pageSize,
          pageNum: this.tablePage.pageNum,
        };
        const { status, data } = await getRecycleBin(params);
        if (status === 1) {
          this.tablePage.total = data.total;
          this.recycleBinItems = data.list.map(item => ({
            ...item,
            createTime: new Date(item.createTime).toLocaleString(),
            participantCount: item.participantCount || 0,
          }));
        } else {
          this.error = '获取回收站数据失败';
        }
      } catch (err) {
        this.error = '无法加载回收站数据，请稍后再试。';
      } finally {
        this.loading = false;
      }
    },

    getActivityTypeText(type) {
      const types = { 106: '通用接龙', 109: '打卡接龙', 201: '通知公告', 303: '信息收集',105: '通用接龙' };
      return types[type] || '其他';
    },

    getActivityStatus(num) {
      const statusMap = {
        1: '未开始',
        2: '已结束',
        3: '进行中',
      };
      return statusMap[num] || '草稿';
    },

    getActivityTypeColor(type) {
      const colors = { 106: '#FFDBD3', 109: '#6a99cf', 201: '#77ed8f', 303: '#dd91ea' ,105:'#FFDBD3'};
      return colors[type] || '#9E9E9E';
    },

    getActivityTypeTextColor(type) {
      const textColors = { 106: '#e60707', 109: '#0f73e3', 201: '#08da33', 303: '#ae12ca',105:'#e60707' };
      return textColors[type] || '#FFFFFF';
    },

    getDartBackgroundColor(isDart) {
      return isDart === 0 ? '#0be838' : '#be0edd';
    },

    getStatusTextColor(isDart) {
      return isDart === 0 ? '#08da33' : '#ae12ca';
    },

    activityTypeStyle(type) {
      return {
        background: `linear-gradient(180deg, ${this.getActivityTypeColor(type)}, #fff)`,
        padding: '3px 8px',
        borderRadius: '5px',
        color: this.getActivityTypeTextColor(type),
      };
    },

    statusStyle(isDart) {
      return {
        backgroundColor: '#fff',
        border: `2px solid ${this.getDartBackgroundColor(isDart)}`,
        padding: '3px 8px',
        borderRadius: '5px',
        color: this.getStatusTextColor(isDart),
      };
    },

    async restore(activityId) {
      this.loading = true;
      try {
        const { status } = await recycleBinRestore({ activityId });
        if (status === 1) {
          this.$message.success('活动恢复成功');
          this.fetchRecycleBinData();
        } else {
          this.$message.error('恢复失败');
        }
      } catch (error) {
        this.$message.error('恢复请求失败');
      } finally {
        this.loading = false;
      }
    },

    async deleteItem(activityId) {
      this.loading = true;
      try {
        const { status } = await recycleBinKill({ activityId });
        if (status === 1) {
          this.$message.success('活动删除成功');
          this.fetchRecycleBinData();
        } else {
          this.$message.error('删除失败');
        }
      } catch (error) {
        this.$message.error('删除请求失败');
      } finally {
        this.loading = false;
      }
    },

    confirmRestore(activityId) {
      this.currentItemId = activityId;
      this.showRestoreDialog = true;
    },

    confirmDelete(activityId) {
      this.currentItemId = activityId;
      this.showDeleteDialog = true;
    },

    restoreActivity() {
      this.restore(this.currentItemId);
      this.resetRestoreDialog();
    },

    deleteActivity() {
      this.deleteItem(this.currentItemId);
      this.resetDeleteDialog();
    },

    resetRestoreDialog() {
      this.showRestoreDialog = false;
      this.currentItemId = null;
    },

    resetDeleteDialog() {
      this.showDeleteDialog = false;
      this.currentItemId = null;
    },

    handleSizeChange(size) {
      this.tablePage.pageSize = size;
      this.tablePage.pageNum = 1;
      this.fetchRecycleBinData();
    },

    handlePageChange(page) {
      this.tablePage.pageNum = page;
      this.fetchRecycleBinData();
    },

    getStatusClass(isDart) {
      if (isDart === 1) {
        return 'alreadyend';
      } else if (isDart === 2) {
        return 'alreadyend';
      } else if (isDart === 3) {
        return 'going';
      } else {
        return 'nobegin';
      }
    },

    formatDateTime(dateTimeStr) {
      return dateTimeStr.replace(/\//g, '-');
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 100% !important;
  padding: 20px;
}
.outBox {
  margin: 0 auto;
  background: #fbfbfb;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.note {
  font-size: 14px;
  color: #888;
  margin-bottom: 0;
}
.table-container {
  margin-top: 10px;
}
.table {
  width: 100%;
  border-collapse: collapse;
}
.table th, .table td {
  padding: 10px;
  text-align: center;
  border: 1px solid #ddd;
  vertical-align: middle;
}
.table-body {

}
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 50px 0;
  color: #888;
}
.no-data-icon {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
}
.btn {
  padding: 6px 12px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 0 5px;
  font-size: 12px;
}
.btn-restore {
  background: #4caf50;
  color: #fff;
}
.btn-delete {
  background: #f44336;
  color: #fff;
}
.no-data-text {
  font-size: 16px;
  margin-bottom: 10px;
}

.cgclass {
    margin-top: 2px;
    margin-right: 5px;
    margin-left: 15px;
    font-size: 12px;
    line-height: 19px;
    width: 45px;
    height: 19px;
    background: #fea951;
    border: 1px solid #fea951;
    border-radius: 4px;
    color: white;
}



.jlclass {
    width: 60px;
    height: 20px;
    background: #fff0f0;
    border: 1px solid #feeaea;
    border-radius: 4px;
    color: #F67A7A;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    display: inline-block;
}



.dkclass {
    width: 60px;
    height: 20px;
    background: rgba(85,167,253,0.16);
    border: 1px solid rgba(85,167,253,0.11);
    border-radius: 4px;
    color: #1877ff;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    display: inline-block;

}
.tzclass{
    width: 60px;
    height: 20px;
    background:  rgba(27,206,74,0.16);;
    border: 1px solid rgba(27,206,74,0.11);
    border-radius: 4px;
    color: #1BCE4A;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    display: inline-block;
}

.hyclass{
    width: 60px;
    height: 20px;
    background: rgba(107,27,206,0.16);
    border: 1px solid rgba(107,27,206,0.11);
    border-radius: 4px;
    color: #6B1BCE;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    display: inline-block;
}

.wzClass {
    overflow: auto;
    height: 439px;
    // text-align: center;
    justify-content: center;
    // display: flex;
    // flex-direction: column;
    padding-left: 27px;
    margin-top: 10px;
}
.nobegin {

    margin-top: 2px;

    margin-right: 5px;

    margin-left: 15px;

    font-size: 12px;

    line-height: 19px;

    width: 45px;

    height: 19px;

    background: #fff0f0;

    border: 1px solid #feeaea;

    border-radius: 4px;

    color: #f67a7a;

}

.alreadyend {

    margin-top: 2px;

    margin-right: 5px;

    margin-left: 15px;

    font-size: 12px;

    line-height: 19px;

    width: 45px;

    height: 19px;

    background: #d8d8d8;

    border: 1px solid #d8d8d8;

    border-radius: 4px;

    color: white;

}

.going {

    margin-top: 2px;

    margin-right: 5px;

    margin-left: 15px;

    font-size: 12px;

    line-height: 19px;

    width: 45px;

    height: 19px;

    background: #1bce4a;

    border: 1px solid #1bce4a;

    border-radius: 4px;

    color: white;

}
.acStyle {

    width: 120px;

    height: 30px;

    background-color: rgb(64, 158, 255);

    color: white;

    font-size: 12px;

    border: 0;

}



.defStyle {

    width: 120px;

    height: 30px;

    background-color: white;

    color: rgb(64, 158, 255);

    font-size: 12px;

    border: 1px solid rgb(64, 158, 255);

}
</style>
